import React from "react";

/**
 * DefaultPlaceholder is a functional component that renders a placeholder section.
 * It displays the content type and rendering of the passed data.
 *
 * @param {Object} data - The data to be displayed.
 * @returns {JSX.Element} A section element containing the content type and rendering of the data.
 */
const DefaultPlaceholder = ({ data }) => (
    <section className="py-17">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <h4 className="mb-2">Default Placeholder Component</h4>
                    {/* Displaying the content type of the data */}
                    {/* eslint-disable-next-line no-underscore-dangle */}
                    <p>Content Type: {data.__typename}</p>
                    {/* Displaying the rendering of the data */}
                    <p>Rendering: {data.frontEndComponent}</p>
                </div>
            </div>
        </div>
    </section>
);

export default DefaultPlaceholder;
